import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isCloud } = useAuth();
  const navigate = useNavigate();

  // ── Cloud mode: Google Sign-In ──────────────────────────────────────────
  if (isCloud) {
    const handleGoogleLogin = async () => {
      setLoading(true);
      setError('');
      try {
        await login(); // triggers Google OAuth redirect
      } catch (err) {
        setError('Sign-in failed. Please try again.');
        setLoading(false);
      }
    };

    return (
      <div className="login-container">
        <div className="login-form">
          <h2>FantaSea Fishing</h2>
          <p style={{ marginBottom: '1.5rem', color: 'var(--color-text-muted, #888)' }}>
            Sign in with your authorized Google account to access the tournament app.
          </p>
          <button
            className="login-button"
            onClick={handleGoogleLogin}
            disabled={loading}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
          >
            {loading ? 'Redirecting…' : 'Sign in with Google'}
          </button>
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    );
  }

  // ── Local mode: password form (unchanged) ───────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const response = await login(password);
    if (response.ok) {
      navigate('/');
    } else {
      setError('Invalid password');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login</h2>
        <div className="form-group" style={{ display: 'none' }}>
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            autoComplete="username"
            defaultValue="user"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Logging in…' : 'Login'}
        </button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
}

export default Login;
